import script from "./tooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./tooltip.vue?vue&type=script&lang=ts&setup=true"

import "./tooltip.vue?vue&type=style&index=0&id=18fd9352&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18fd9352"]])

export default __exports__